import { render, staticRenderFns } from "./OrdersContent.vue?vue&type=template&id=5b74ed13&scoped=true&"
import script from "./OrdersContent.vue?vue&type=script&lang=js&"
export * from "./OrdersContent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5b74ed13",
  null
  
)

export default component.exports